import { createContext } from 'react';
import { User } from 'src/libs/wa/models/entities/User';

type AuthContextType = {
  user: User | undefined | null;
  isLoading: boolean;
};

export const AuthContext = createContext<AuthContextType>({ user: null, isLoading: true }); // null..apiFetchが終わってない, undefined..未ログイン状態
